export default {
  path: '/activities',
  component: () => import('@/layouts/PublicLayout'),
  children: [
    {
      path: 'invite_user',
      component: () => import('@/views/activities/InviteUser'),
      meta: {
        title: '邀请用户'
      }
    },
    {
      path: 'poster',
      component: () => import('@/views/activities/Poster'),
      meta: {
        title: '邀请用户'
      }
    }
  ]
}
